import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
      orderInfo: JSON.parse(localStorage.getItem('buyOrderInfo') as string) ||{},
  },
  mutations: {
      addOrderInfo(state, payload){
        state.orderInfo = payload
      }
  },
  actions: {
    getAsyncOrderInfo(context, payload){
      context.commit('addOrderInfo',payload)
    }
  },
  modules: {}
});
